import React from 'react'

import { Badge } from '../'
import * as colors from '../../assets/js/colors'
import { PickingStatus } from '../../constants/picking-status'

function BadgeStatusEntrega({ status }) {
  switch (status) {
    case 'Carregada':
      return <Badge color={colors.pink}>{status}</Badge>
    case 'Aguardando Conferência':
      return <Badge color={colors.black}>{status}</Badge>
    case 'Picking Concluído':
      return <Badge color={PickingStatus.PickingConcluido.color}>{status}</Badge>
    case 'Aguardando Carregamento':
      return <Badge color={colors.azul_hover}>{status}</Badge>
    case 'Conferido':
      return <Badge color={colors.verde}>{status}</Badge>
    case 'Entregue':
      return <Badge color={colors.azul}>{status}</Badge>
    case 'Reentrega':
      return <Badge color={colors.laranja}>{status}</Badge>
    case 'Devolução Total':
      return <Badge color={colors.vinho}>{status}</Badge>
    case 'Devolução Parcial':
      return <Badge color={colors.azul_escuro}>{status}</Badge>
    case 'Saiu para Entrega':
      return <Badge color={colors.gray}>Saiu para Entrega</Badge>
    case 'Em Rota':
      return <Badge color={colors.violeta}>Em Rota</Badge>
    case 'No Cliente':
      return <Badge color={colors.verde_escuro}>No cliente</Badge>
    case 'Descarregando':
      return <Badge color={colors.roxo}>Descarregando</Badge>
    case 'Aguardando Reposição de Falta':
      return <Badge color={colors.azul_claro}>{status}</Badge>
    case 'Aguardando Agendamento':
      return <Badge color={colors.error}>{status}</Badge>
    case 'Em Transferência':
      return <Badge color={colors.verde_success}>{status}</Badge>
    default:
      return null
  }
}

export default BadgeStatusEntrega
